import config from '../utils/config';

const messageAuth = `
    <p>Вітаю! Авторизуйтесь в <a href="${config.URL_ID3_CABINET}/login" target="_blank">Особистому кабінеті</a>, щоб потрапити на захід. Якщо Ви вже реєструвались
    <br>
    на сайтах Цифрового видавництва Експертус, то скористайтеся своїм логіном і паролем -
    <br>
    сайт обов'язково дізнається про Вас.</p>
    <p>Або зареєструйтеся, перейшовши за посиланням «<a href="${config.URL_ID3_CABINET}/registration" target="_blank">Зареєструватися</a>». При реєстрації обов'язково
    <br>
    вкажіть адресу діючої електронної пошти. Вона потрібна, щоб відновити пароль. Введіть ваш
    <br>
    номер телефону - на нього відправимо код для завершення реєстрації.</p>
`;

const messageAccess = `
    <p>Вітаю! На жаль, у Вас немає доступу до заходу. Ви маєте оплатити <a href="${window.location.origin}/seminar" target="_blank">участь у заході</a>, який 
    <br> 
    Вас цікавить, або активувати код доступу до заходу, який Ви отримали раніше на Вашу
    <br>
    електронну скриньку.</p>
    <p>Не вдалося знайти лист з кодом доступу ­— телефонуйте 0 800 21 38 38</p>
`;

const messageRegisterVebinar = (link: string) => `
    <p>Щоб переглянути вебінар, будь ласка, зареєструйтеся за <a href="${window.location.origin}/${link || ''}" target="_blank">посиланням</a></p>
`;

const messageAuthVebinar = `
    <p>Щоб переглянути вебінар та поставити запитання лектору, будь ласка, авторизуйтеся. 
    <br> 
    Натисніть на кнопку «Вхід та реєстрація» в правому верхньому кутику сторінки.</p>
`;

export const messageErrors = {
  messageAuth,
  messageAccess,
  messageRegisterVebinar,
  messageAuthVebinar,
};
